type IconProps = JSX.IntrinsicElements['svg'] & {
    direction?: 'up' | 'down' | 'left' | 'right'
    className?: string
}

export const IconLogo = (props: IconProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox={`0 0 ${props.width ?? 94} ${props.height ?? 27}`}
            width={props.width ?? 94}
            height={props.height ?? 27}
            className={props.className}
            {...props}
        >
            <path
                d="M5.96322 0.922717C4.88281 2.41505 1.33496 7.09112 1.33496 13.4877C1.33496 19.9147 4.88137 24.5908 5.96322 26.0816L5.03757 27C2.1073 23.2699 0 18.479 0 13.4862C0 8.52532 2.1073 3.73446 5.03612 0L5.96322 0.922717Z"
                fill={props.fill ?? '#000080'}
            />
            <path
                d="M12.6685 8.92637C14.2506 8.73918 15.8149 8.42281 17.3459 7.98041C18.6563 7.66508 24.4648 5.62784 26.7775 5.62784C30.1445 5.62784 33.6143 8.52532 33.6143 12.748C33.6143 16.42 32.1491 18.543 31.4809 19.3465C30.5553 20.4654 27.3169 22.9604 20.8923 23.3048L19.6326 21.0394C23.8472 21.0394 27.4977 20.4654 29.861 18.1129C30.8894 17.0506 31.7123 15.0148 31.7123 13.027C31.7123 10.8764 30.4265 7.46165 26.6748 7.46165C23.9759 7.46165 15.444 11.1627 13.8762 11.1627L12.6685 8.92637Z"
                fill={props.fill ?? '#000080'}
            />
            <path
                d="M38.5535 9.38556C40.1186 9.20676 41.6665 8.89962 43.1818 8.4672C44.4922 8.15188 50.1242 6.11464 52.4383 6.11464C55.8025 6.11464 59.2737 9.00921 59.2737 13.2014C59.2737 16.9024 57.81 19.0254 57.1418 19.8275C56.2161 20.9464 52.9778 23.4428 46.5532 23.8729L45.2934 21.4637C49.508 21.4637 53.1571 20.9464 55.5219 18.5938C56.5502 17.5331 57.3717 15.4958 57.3717 13.5167C57.3717 11.3647 56.0874 7.95135 52.3356 7.95135C50.0215 7.95135 41.2321 11.6233 39.767 11.6233L38.5535 9.38556ZM54.1276 1.84108C54.7192 2.55746 55.8502 4.56564 56.1525 5.3692L54.6165 6.05797C54.2824 5.19774 53.254 3.33196 52.6119 2.61558L54.1276 1.84108ZM57.1649 1.58243C57.7565 2.30026 58.8875 4.30844 59.1898 5.112L57.648 5.79932C57.3139 4.93908 56.2855 3.07476 55.6434 2.35693L57.1649 1.58243Z"
                fill={props.fill ?? '#000080'}
            />
            <path
                d="M76.5008 26.0817C70.3842 15.7254 66.6571 16.5581 66.6571 13.431C66.6571 10.5335 71.926 8.98451 75.8065 1.00846L77.4264 3.07477C71.3099 11.279 68.9451 11.9968 68.9451 13.3162C68.9451 14.8361 74.2966 17.9341 78.2234 24.3031L76.5008 26.0817Z"
                fill={props.fill ?? '#000080'}
            />
            <path
                d="M88.9639 0C91.8927 3.7301 94 8.52096 94 13.4833C94 18.4747 91.8927 23.2655 88.9639 26.9971L88.0382 26.0787C89.1172 24.5879 92.6665 19.9118 92.6665 13.4847C92.6665 7.09112 89.1201 2.41214 88.0382 0.919811L88.9639 0Z"
                fill={props.fill ?? '#000080'}
            />
        </svg>
    )
}

export const IconInstagram = (props: IconProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox={`0 0 ${props.width ?? 19} ${props.height ?? 19}`}
            width={props.width ?? 19}
            height={props.height ?? 19}
            className={props.className}
            {...props}
        >
            <path
                d="M18.9973 5.58092C18.9758 4.79142 18.8261 4.01067 18.5539 3.26925C18.3019 2.63494 17.92 2.06032 17.4328 1.58225C16.9457 1.10418 16.364 0.73321 15.725 0.493138C14.9836 0.221002 14.2028 0.0712692 13.4134 0.0498047C12.3578 0.0498047 12.0728 0.0498047 9.49727 0.0498047C6.92172 0.0498047 6.59449 0.0498047 5.58116 0.0498047C4.79167 0.0712692 4.01092 0.221002 3.26949 0.493138C2.64031 0.739361 2.06886 1.1131 1.59111 1.59086C1.11334 2.06862 0.739605 2.64006 0.493382 3.26925C0.221246 4.01067 0.0715132 4.79142 0.0500488 5.58092C0.0500488 6.63647 0.0500488 6.92147 0.0500488 9.49703C0.0500488 12.0726 0.0500488 12.3998 0.0500488 13.4131C0.0715132 14.2026 0.221246 14.9834 0.493382 15.7248C0.739605 16.354 1.11334 16.9254 1.59111 17.4032C2.06886 17.881 2.64031 18.2547 3.26949 18.5009C4.00789 18.7911 4.78872 18.9587 5.58116 18.997C6.63672 18.997 6.92172 19.0498 9.49727 19.0498C12.0728 19.0498 12.4 19.0498 13.4134 18.997C14.2028 18.9756 14.9836 18.8258 15.725 18.5537C16.3543 18.3074 16.9256 17.9338 17.4035 17.456C17.8812 16.9782 18.2549 16.4068 18.5012 15.7776C18.797 15.0225 18.9647 14.2234 18.9973 13.4131C18.9973 12.3576 19.05 12.0726 19.05 9.49703C19.05 6.92147 18.9973 6.59425 18.9973 5.58092ZM17.2978 13.3392C17.2616 13.9494 17.1225 14.5489 16.8862 15.1126C16.7228 15.5108 16.4818 15.8727 16.1774 16.1771C15.8729 16.4815 15.5111 16.7225 15.1128 16.8859C14.5442 17.0933 13.9447 17.204 13.3395 17.2131C12.2839 17.2131 12.0412 17.2659 9.49727 17.2659C6.95338 17.2659 6.65783 17.2659 5.65505 17.2131C5.0498 17.204 4.45039 17.0933 3.88172 16.8859C3.48129 16.7273 3.12085 16.4822 2.82616 16.1681C2.51208 15.8734 2.26698 15.513 2.10838 15.1126C1.90096 14.544 1.79035 13.9445 1.78116 13.3392C1.78116 12.3365 1.72838 12.0409 1.72838 9.49703C1.72838 6.95314 1.72838 6.65758 1.78116 5.6548C1.79035 5.04956 1.90096 4.45014 2.10838 3.88147C2.26698 3.48105 2.51208 3.12061 2.82616 2.82592C3.12085 2.51184 3.48129 2.26674 3.88172 2.10814C4.45039 1.90071 5.0498 1.79011 5.65505 1.78092C6.7106 1.78092 6.95338 1.78092 9.49727 1.78092C12.0412 1.78092 12.3367 1.78092 13.3395 1.78092C13.9447 1.79011 14.5442 1.90071 15.1128 2.10814C15.5111 2.27159 15.8729 2.51251 16.1774 2.81693C16.4818 3.12134 16.7228 3.4832 16.8862 3.88147C17.0936 4.45014 17.2042 5.04956 17.2134 5.6548C17.2134 6.71036 17.2662 6.95314 17.2662 9.49703C17.2662 12.0409 17.2873 12.3365 17.2451 13.3392H17.2978ZM9.49727 4.62036C8.53276 4.62036 7.5899 4.90637 6.78794 5.44223C5.98598 5.97808 5.36092 6.73972 4.99182 7.6308C4.62272 8.5219 4.52614 9.50244 4.71431 10.4484C4.90248 11.3944 5.36693 12.2633 6.04895 12.9453C6.73097 13.6274 7.5999 14.0919 8.54588 14.28C9.49186 14.4682 10.4724 14.3716 11.3635 14.0025C12.2546 13.6333 13.0162 13.0083 13.5521 12.2063C14.0879 11.4044 14.3739 10.4615 14.3739 9.49703C14.3739 8.20365 13.8602 6.96325 12.9456 6.04871C12.031 5.13415 10.7906 4.62036 9.49727 4.62036ZM9.49727 12.6637C8.87097 12.6637 8.25872 12.478 7.73797 12.13C7.21721 11.7821 6.81133 11.2875 6.57165 10.7089C6.33198 10.1302 6.26927 9.49351 6.39145 8.87924C6.51364 8.26497 6.81523 7.70072 7.2581 7.25786C7.70097 6.81499 8.26522 6.51339 8.87949 6.3912C9.49376 6.26902 10.1305 6.33173 10.7092 6.57141C11.2877 6.81108 11.7823 7.21696 12.1302 7.73772C12.4783 8.25848 12.6639 8.87072 12.6639 9.49703C12.6639 10.3369 12.3303 11.1423 11.7364 11.7362C11.1426 12.33 10.3371 12.6637 9.49727 12.6637ZM14.5639 3.29036C14.338 3.28827 14.1166 3.35335 13.9278 3.47733C13.7389 3.60132 13.5911 3.77862 13.5032 3.98674C13.4153 4.19486 13.3912 4.4244 13.434 4.64622C13.4768 4.86805 13.5845 5.07217 13.7436 5.23266C13.9025 5.39314 14.1056 5.50277 14.3271 5.54762C14.5485 5.59247 14.7782 5.57052 14.9872 5.48455C15.1961 5.39859 15.3747 5.25249 15.5005 5.06479C15.6262 4.8771 15.6934 4.65628 15.6934 4.43036C15.6934 4.13081 15.5744 3.84353 15.3626 3.63173C15.1507 3.41991 14.8635 3.30092 14.5639 3.30092V3.29036Z"
                fill={props.fill ?? '#000080'}
            />
        </svg>
    )
}

export const IconTwitter = (props: IconProps) => {
    return (
        <svg
            viewBox={`0 0 ${props.width ?? 19} ${props.height ?? 19}`}
            width={props.width ?? 19}
            height={props.height ?? 19}
            className={props.className}
            {...props}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11.3076 8.222L18.3808 0H16.7046L10.563 7.13904L5.65769 0H0L7.41779 10.7955L0 19.4175H1.67621L8.16194 11.8785L13.3423 19.4175H19L11.3072 8.222H11.3076ZM9.01178 10.8906L8.2602 9.81562L2.28017 1.26183H4.85474L9.68069 8.16501L10.4323 9.24L16.7054 18.2131H14.1309L9.01178 10.891V10.8906Z"
                fill={props.fill ?? '#000080'}
            />
        </svg>
    )
}

export const IconMenu = (props: IconProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.width ?? 60}
            height={props.height ?? 60}
            viewBox={`0 0 ${props.width ?? 60} ${props.height ?? 60}`}
            fill="none"
            className={props.className}
            {...props}
        >
            <rect
                x="60"
                width="60"
                height="60"
                transform="rotate(90 60 0)"
                fill="white"
            />
            <line x1="12" y1="29.5" x2="49" y2="29.5" stroke="#000080" />
            <line x1="30.5" y1="11" x2="30.5" y2="48" stroke="#000080" />
        </svg>
    )
}

export const IconArrow = (props: IconProps) => {
    const rotation =
        props.direction === 'up'
            ? 'rotate-180'
            : props.direction === 'down'
            ? 'rotate-0'
            : props.direction === 'left'
            ? 'rotate-90'
            : props.direction === 'right'
            ? '-rotate-90'
            : ''

    return (
        <svg
            width="36"
            height="38"
            viewBox="0 0 36 38"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`${props.className} ${rotation}`}
        >
            <path
                d="M34.7069 19.7726L17.71 36.7696M17.71 36.7696L0.713033 19.7726M17.71 36.7696L17.71 0"
                stroke={props.stroke ?? '#000080'}
            />
        </svg>
    )
}

export const IconPlayVideo = (props: IconProps) => {
    return (
        <svg
            width="134"
            height="134"
            viewBox="0 0 134 134"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={props.className}
        >
            <path d="M84 67L57 79L57 55L84 67Z" fill="white" />
            <circle cx="67" cy="67" r="66.5" stroke="white" />
        </svg>
    )
}
